module.exports = __webpack_public_path__ + "static/media/signal-icon2.19f7c53d.svg";